import React from 'react';
import PropTypes from 'prop-types';

import { Fab as MuiFabButton } from '@material-ui/core';

const Fab = ({ children, onClick, ...rest }) => {
    return (
      <MuiFabButton
        {...rest}
        onClick={onClick}
      >
        { children }
      </MuiFabButton>
    )
  }
  
  Fab.defaultProps = {
    onClick: () => {},
  };
  
  Fab.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
  };
  
  export default Fab;
  


// WEBPACK FOOTER //
// ./src/components/base/Buttons/FabButton.js